import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { preparePaginationData } from "../constant/common";
import { getReq } from "../services/APIMethods";
import { alertMsg } from "../utilities/helper";

export const getAllCategoriesStatistics = createAsyncThunk(
  "categoriesStatistics/getAllCategoriesStatistics",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await getReq(obj);
      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);

export const getAllCategoriesTabel = createAsyncThunk(
  "categoriesStatistics/getAllCategoriesTabel",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await getReq(obj);
      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);

export const categoriesStatistics = createSlice({
  name: "categoriesStatistics",
  initialState: {
    render: false,
    id: null,
    delete: false,
    loading: false,
    allCategories: [],
    allCategoriesTabel: [],
    categories: {},
    success: null,
    successData: null,
    error: "",
    errorMsg: null,
  },

  //get all categoriesStatistics apis
  extraReducers: {
    //get all categoriesStatistics data
    [getAllCategoriesStatistics.pending]: (state) => {
      state.loading = true;
    },
    [getAllCategoriesStatistics.fulfilled]: (state, action) => {
      state.loading = false;
      state.allCategories = action.payload.data;
    },
    [getAllCategoriesStatistics.rejected]: (state, action) => {
      state.allCategories = null;
      state.loading = false;
      state.success = action.payload.response?.data?.success;
      state.error = action.payload.response?.data?.error;
    },
    //get all categoriesStatistics tabel data
    [getAllCategoriesTabel.pending]: (state) => {
      state.loading = true;
    },
    [getAllCategoriesTabel.fulfilled]: (state, action) => {
      state.loading = false;
      state.allCategoriesTabel = action.payload.data;
    },
    [getAllCategoriesTabel.rejected]: (state, action) => {
      state.allCategoriesTabel = null;
      state.loading = false;
      state.success = action.payload.response?.data?.success;
      state.error = action.payload.response?.data?.error;
    },
  },
});
export default categoriesStatistics.reducer;
export const {
  setServicesAirports,
  setDelete,
  deleteAirportsRTK,
  renderAirports,
  setAirportID,
} = categoriesStatistics.actions;
